/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSourceTagRequest
 */
export interface CreateSourceTagRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the CreateSourceTagRequest interface.
 */
export function instanceOfCreateSourceTagRequest(value: object): value is CreateSourceTagRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateSourceTagRequestFromJSON(json: any): CreateSourceTagRequest {
    return CreateSourceTagRequestFromJSONTyped(json, false);
}

export function CreateSourceTagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourceTagRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CreateSourceTagRequestToJSON(json: any): CreateSourceTagRequest {
    return CreateSourceTagRequestToJSONTyped(json, false);
}

export function CreateSourceTagRequestToJSONTyped(value?: CreateSourceTagRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

